import React, { FC } from 'react'

export const Mail: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z"
      stroke="#262628"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 4.5 10 10l7.5-5.5m-15 11L6 13m11.5 2.5L14 13"
      stroke="#262628"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
